/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'ship/corvette_1': {
    width: 32,
    height: 32,
    viewBox: '0 0 32 32',
    data: '<circle pid="0" cx="30" cy="30" r="2"/><circle pid="1" cx="2" cy="2" r="2"/><path pid="2" d="M14 12c0-2 2-4 2-4s2 2 2 4v5h-4v-5zM10 23h12l-2-4h-8zM15 23h2v2h-2zM19.5 18h-7a.5.5 0 010-1h7c.275 0 .5.225.5.5s-.225.5-.5.5z"/><g><path pid="3" d="M3 13.254H2v-5.29L6.587 5.33l.498.867L3 8.543zM8.764 5.233l-.498-.867 1.68-.965.498.868zM20.087 3.424L16 1.077l-4.087 2.347-.498-.867L16-.077l4.585 2.634zM23.446 5.353l-1.68-.964.498-.867 1.68.964zM30 13.254h-1V8.543l-4.085-2.346.498-.867L30 7.964zM29 15.165h1v1.911h-1zM25.413 26.671l-.498-.866L29 23.458v-4.71h1v5.29zM22.055 28.6l-.498-.868 1.68-.964.497.867zM16 32.077l-4.585-2.634.498-.866L16 30.923l4.087-2.346.498.866zM9.736 28.481l-1.679-.965.498-.867 1.679.965zM6.587 26.671L2 24.038v-5.29h1v4.71l4.085 2.347zM2 14.926h1v1.911H2z"/></g>'
  }
})
